import { Mark } from '../context/product_context'
import { del, get, post, put } from './generic'

export interface MarkApiData {
    idMarca: number
    nome: string
}

export function parseMark(data: MarkApiData): Mark {
    return {
        id: data.idMarca,
        name: data.nome,
    }
}

export async function getAllMarks(): Promise<Mark[]> {
    const res = await get('marca')
    return res.data.data.map((mark: MarkApiData) => parseMark(mark))
}

export async function getMarkById(id: number): Promise<Mark> {
    const res = await get(`marca/${id}`)
    return parseMark(res.data.data.brand)
}

export async function createMark(name: string): Promise<Mark> {
    const res = await post(
        'marca',
        { nome: name },
        {
            useRecaptcha: true,
        }
    )
    return parseMark(res.data.data.brand)
}

export async function updateMark(id: number, name: string): Promise<void> {
    await put(
        'marca',
        { id, nome: name },
        {
            useRecaptcha: true,
        }
    )
}

export async function deleteMark(id: number): Promise<void> {
    await del(`marca/${id}`, undefined, {
        useRecaptcha: true,
    })
}
